<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="file_027">4. Sculpting</a></h3><a id="file_027">
<p class="noindent">Stone and clay sculpture is often done by starting with a large mass. The artist creates the sculpture by removing material from the start. Sculptural needle felting is different. The sculpture is created by adding to, rather than removing from the material. All of the projects in this book start with a core and pieces are added to the core.</p>
<p class="indent">Hold a strip of wool roving in your hand. With your fingertips, gradually pull the layers of wool apart from each other. It is good to start the sculpture process with layers of wool rather than trying to work with a large mass. It is much more difficult to get the wool to behave the way you’d like it to when you start out with too much. Building layers is the way to go.</p>
<p class="indent">As you read the projects, you will often see the phrase “keep the fibers loose at one end” after sculpting a body part. It is easier to connect pieces together if the fibers are loose and not already felted. That way, the loose fibers will felt onto the fibers of the body and create a secure attachment. Adding a bit more wool around the attachment will make it look smooth and natural (see <strong>G–J</strong>).</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_027.vue?2285787b